import confirmDialog from '@/lib/confirmDialog';

const handleEnterRawObject = async (e, argument, values, actions, dataSourcePath, dataSavePath) => {
  e.preventDefault();
  e.stopPropagation();

  // This leaves you with either "key[" or "key." so you don't need to know the index.
  const parentKey = argument?.key?.endsWith('[]') ? argument?.key?.slice(0, -1) : `${argument?.key}.`;
  const childKeys = [];
  const newArgs = { ...(values || {}) };

  for (const key in newArgs) {
    if (key.startsWith(parentKey)) {
      childKeys.push(key);
      delete newArgs[key];
    }
  }

  newArgs[argument.key] = { type: 'lexical', value: null };

  if (childKeys.length) {
    const confirm = await confirmDialog({
      title: `Are you sure you want to use variables for this ${argument?.dataType}?`,
      message: `This will get rid of any children for this argument. Are you sure you want to proceed?`
    });
    if (confirm !== true) {
      return;
    }
  }

  actions.set(dataSavePath ? `${dataSavePath}.arguments` : dataSourcePath, { ...newArgs });
};

export default handleEnterRawObject;
